import { Link } from "react-router-dom";
import type { PostItem } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

interface PostListItemProps {
  post: PostItem;
  rank?: number;
}

export default function PostListItem({ post, rank }: PostListItemProps) {
  return (
    <Link
      to={`/article/${post.id}`}
      className="group flex items-center gap-3 py-3.5"
    >
      {typeof rank === "number" && (
        <span
          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
            rank <= 3
              ? "bg-primary-500 text-background-50"
              : "bg-background-200 text-foreground-700"
          }`}
        >
          {rank}
        </span>
      )}
      <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md">
        <img
          src={post.cover}
          alt={`${post.title}相关配图`}
          title={`${post.title} - 吃瓜看料`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <h4 className="font-heading text-sm font-semibold leading-snug text-foreground-950 line-clamp-2 transition-colors group-hover:text-primary-600">
          {post.title}
        </h4>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{post.categoryName}</span>
          <span className="text-foreground-300">·</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
            {formatCount(post.heat)}
          </span>
        </div>
      </div>
    </Link>
  );
}